import get from "lodash/get";
import React from "react";
import BSInput from "../../../common/js/components/BSInput";
import BSSelect from "../../../common/js/components/BSSelect";
import MultiAddInput from "../../../common/js/components/MultiAddInput";
import { user_role_type_display_name } from "../auth/constants";
import { us_states_options } from "../utils/constants";
import { keyValueOptionsBuilder } from "../utils/operations";
import Proxy from "./Proxy";

class UserAccountDetail extends React.Component {
    render() {
        const {
            userAccount,
            errors,
            disableInputs,
            handleInputChange,
            handleAddArrayElement,
            handleDeleteArrayElement,
            handleUpdateArrayElement,
            handleSearchUsers,
        } = this.props;

        return (
            <React.Fragment>
                <div style={{ display: "flex", gap: "1vw" }}>
                    <BSInput
                        id="firstName"
                        label="FIRST NAME"
                        value={get(userAccount, "person.firstName", null)}
                        disabled={true}
                    />
                    <BSInput
                        id="lastName"
                        label="LAST NAME"
                        value={get(userAccount, "person.lastName", null)}
                        disabled={true}
                    />
                </div>
                <div style={{ display: "flex", gap: "1vw" }}>
                    <BSInput id="email" label="EMAIL" value={get(userAccount, "email", null)} disabled={true} />
                    <BSInput
                        id="department"
                        label="DEPARTMENT"
                        value={get(userAccount, "department", null)}
                        disabled={true}
                    />
                </div>
                <div style={{ display: "flex", gap: "1vw" }}>
                    <BSInput id="title" label="TITLE" value={get(userAccount, "title", null)} disabled={true} />
                    <BSInput
                        id="speciality"
                        label="SPECIALITY"
                        value={get(userAccount, "speciality", null)}
                        disabled={true}
                    />
                </div>
                <div style={{ display: "flex", gap: "1vw" }}>
                    <BSInput
                        id="primaryPhoneNumber"
                        label="DIRECT PHONE"
                        value={get(userAccount, "primaryPhoneNumber", null)}
                        disabled={true}
                        phone={true}
                    />
                    <BSInput
                        id="secondaryPhoneNumber"
                        label="MOBILE PHONE"
                        value={get(userAccount, "secondaryPhoneNumber", null)}
                        disabled={true}
                        phone={true}
                    />
                </div>
                <BSInput
                    id="address"
                    label="ADDRESS"
                    value={get(userAccount, "person.address.address1", null)}
                    disabled={true}
                />
                <div style={{ display: "flex", gap: "1vw" }}>
                    <BSInput
                        id="city"
                        label="CITY"
                        value={get(userAccount, "person.address.city.city", null)}
                        disabled={true}
                        extraFormControlStyles={{ flex: "1 1 0" }}
                    />
                    <BSSelect
                        id="stateCode"
                        label="STATE"
                        value={get(userAccount, "person.address.city.state.stateCode", null)}
                        options={us_states_options}
                        disabled={true}
                        extraFormControlStyles={{ flex: "1 1 0" }}
                    />
                    <BSInput
                        id="zipCode"
                        label="ZIP CODE"
                        value={get(userAccount, "person.address.zipCode.zipCode", null)}
                        disabled={true}
                        extraFormControlStyles={{ flex: "1 1 0" }}
                    />
                </div>
                <BSInput
                    id="office"
                    label="OFFICE"
                    value={get(userAccount, "office.officeName", null)}
                    disabled={true}
                />
                <BSSelect
                    id="role"
                    label="USER TYPE"
                    value={get(userAccount, "role", null)}
                    error={errors.role}
                    options={keyValueOptionsBuilder(user_role_type_display_name)}
                    onChange={(e) => handleInputChange("userAccount.role", e.target.value)}
                />
                <MultiAddInput
                    addButtonText="Add Proxy"
                    disableInputs={disableInputs === true}
                    displayFirstWhenEmpty={false}
                    elements={get(userAccount, "allowedProxies", [])}
                    onAdd={() => handleAddArrayElement("userAccount.allowedProxies")}
                    onUpdate={(e, index) =>
                        handleUpdateArrayElement("userAccount.allowedProxies", index, e.target.id, e.target.value)
                    }
                    render={(element, elementIndex) => (
                        <Proxy
                            element={element}
                            elementIndex={elementIndex}
                            onSearch={(term) => handleSearchUsers(term)}
                            onDelete={(index) => handleDeleteArrayElement("userAccount.allowedProxies", index)}
                            {...this.props}
                        />
                    )}
                />
            </React.Fragment>
        );
    }
}

export default UserAccountDetail;
